
import { useTheme } from "next-themes"
import { Toaster as SonnerToaster } from "sonner"
import React from "react" // Add React import
import { defaultToastConfig } from "@/utils/toastConfig"

type ToasterProps = React.ComponentProps<typeof SonnerToaster>

const Toaster = ({ ...props }: ToasterProps) => {
  // Add a try/catch to handle cases where ThemeContext isn't available
  let theme = "system"
  try {
    const themeContext = useTheme()
    theme = themeContext?.theme || "system"
  } catch (error) {
    console.warn("Theme context not available, defaulting to system theme")
  }

  return (
    <SonnerToaster
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      duration={defaultToastConfig.duration}
      position={defaultToastConfig.position}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
